export default import.meta.ROLLDOWN_FILE_URL_sSgKM7lpy2YT210BHuEaKw